/* eslint-disable */
import { createSelector } from 'reselect';
import { isNull, isUndefined } from 'lodash';

const getOrdersState = (state) => state.orders;

export const ordersSelector = createSelector([getOrdersState], (ordersState) => {
  const {
    isFetching,
    error,
    pagination,
    paginationFetching,
    actionFetching,
    filters,
    exportData,
    exportListFetching,
    users,
    exportConfig,
    data,
    config,
  } = ordersState;

  return {
    filters,
    isFetching,
    paginationFetching,
    error,
    actionFetching,
    exportData,
    exportConfig,
    exportListFetching,
    users,
    pagination,
    config,
    selling_at_lost: data?.selling_at_lost,
    orders: data?.orders,
    statuses: data?.statuses,
    access: data?.access,
    bulk_actions: data?.bulk_actions,
    need_pagination: data?.need_pagination,
  };
});
